import { useState } from "react"

const PaginationContainer = () => {
  const el = document.getElementById("mm-pagination-container")
  if (!el) return null

  const totalPages = parseInt(el.getAttribute("data-total-pages"))
  const initialPage = parseInt(el.getAttribute("data-current-page"))
  const container = el.getAttribute("data-target-container-id") || "mm-song-versions-container"
  const dataAttribute = el.getAttribute("data-attribute") || "data-song-versions"

  const [currentPage, setCurrentPage] = useState(initialPage)
  const [isLoading, setIsLoading] = useState(false)

  const updateContainerData = (doc) => {
    const currentEl = document.getElementById(container)
    const newData = doc.getElementById(container)?.getAttribute(dataAttribute)

    if (currentEl && newData) {
      currentEl.setAttribute(dataAttribute, newData)
      currentEl.dispatchEvent(new Event("data-updated")) // triggers re-render in listening components
      currentEl.style.visibility = "visible"
    }
  }

  // Syncs pagination attributes from the new HTML and updates current page state
  const updatePaginationAttributes = (doc, fallbackPage) => {
    const newPagination = doc.getElementById("mm-pagination-container")
    if (!newPagination) return

    for (const attr of newPagination.attributes) {
      el.setAttribute(attr.name, attr.value)
    }

    const newPage = parseInt(newPagination.getAttribute("data-current-page") || fallbackPage)
    setCurrentPage(newPage)
  }

  const goToPage = (page) => {
    const url = new URL(window.location.href)
    url.searchParams.set("page", page)
    window.history.pushState({}, "", url)
    
    setIsLoading(true)

    fetch(url.toString())
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html")
        updateContainerData(doc)
        updatePaginationAttributes(doc, page)
      })
      .catch((err) => console.error("Error fetching new page:", err))
      .finally(() => { setIsLoading(false) })
  }

  return (
    <div className="pagination-controls">
      {isLoading && (
        <div className="loading">
          <div className="spinner"></div>
        </div>
      )}
      {!isLoading && (
        <>
          {currentPage > 1 && (
            <>
              <button onClick={() => goToPage(1)}>«</button>
              <button onClick={() => goToPage(currentPage - 1)}>‹</button>
            </>
          )}
  
          {[...Array(totalPages)].map((_, i) => {
            const page = i + 1
            const isVisible =
              Math.abs(page - currentPage) <= 3 ||
              (currentPage <= 4 && page <= 7) ||
              (currentPage >= totalPages - 3 && page >= totalPages - 6)
  
            if (!isVisible) return null
  
            return (
              <button
                key={page}
                onClick={() => goToPage(page)}
                className={page === currentPage ? "selected" : ""}
              >
                {page}
              </button>
            )
          })}
  
          {currentPage < totalPages && (
            <>
              <button onClick={() => goToPage(currentPage + 1)}>›</button>
              <button onClick={() => goToPage(totalPages)}>»</button>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default PaginationContainer
